import React from 'react';
import './brandingComponent.scss';
import {Link} from "react-router-dom";
import {CommonService} from "../../../services";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";

export interface BrandingComponentProps {
    sideMenuView?: string
}

const BrandingComponent = (props: BrandingComponentProps) => {
    const {sideMenuView} = props;
    const {systemConfig} = useSelector((state: IRootReducerState) => state?.staticData);
    const structuredConfig = CommonService.getStructuredSystemConfig(systemConfig?.data)
    return (
        <Link className='logo-container' to={CommonService._routeConfig.Dashboard()}>
            <img src={structuredConfig?.expandLogo}
                 className={`logo ${(sideMenuView === "compact" || sideMenuView === "collapsed") && 'display-none'}`}
                 alt="AdvanzInnovationLogo"/>
            <img src={structuredConfig?.collapseLogo}
                 className={`logo-small ${sideMenuView === "default" && 'display-none'}`}
                 alt="AdvanzInnovationLogo"/>
        </Link>
    )

};

export default BrandingComponent;
